/**
 * AI Settings - API接口
 */

import psHttp from '@patsnap/common-ps-http';
import { DRAFTING_URI } from '@/constants/base-url';
import type { AgentExecutionPreferencesSetting, AILanguageSetting, PreferenceTaskType } from './types';

const BASE_URL = `${DRAFTING_URI}/api/user/settings`;

/**
 * 获取AI输出语言设置
 * 如果用户未设置过，后端会返回根据region计算的默认值
 */
export function getAIOutputLanguage(): Promise<AILanguageSetting> {
    return psHttp({
        url: `${BASE_URL}/ai_output_language`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => data.data);
}

/**
 * 保存AI输出语言设置
 */
export function saveAIOutputLanguage(language: string): Promise<AILanguageSetting> {
    return psHttp({
        url: `${BASE_URL}/ai_output_language`,
        method: 'POST',
        data: { language },
        transformCode: true,
    }).then(({ data }) => data.data);
}

/**
 * 获取指定任务类型的用户执行规范设置
 */
export function getAgentExecutionPreferences(taskType: PreferenceTaskType): Promise<AgentExecutionPreferencesSetting> {
    return psHttp({
        url: `${BASE_URL}/agent_execution_preferences`,
        method: 'GET',
        params: { task_type: taskType },
        transformCode: true,
    }).then(({ data }) => data.data);
}

/**
 * 保存指定任务类型的用户执行规范设置
 */
export function saveAgentExecutionPreferences(
    taskType: PreferenceTaskType,
    content: string,
): Promise<AgentExecutionPreferencesSetting> {
    return psHttp({
        url: `${BASE_URL}/agent_execution_preferences`,
        method: 'POST',
        data: { task_type: taskType, content },
        transformCode: true,
    }).then(({ data }) => data.data);
}
